import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as api from '../api/units-of-measure';

export const useUnits = (params) =>
  useQuery({
    queryKey: ['units-of-measure', params],
    queryFn: () => api.getUnits(params),
  });

export const useCreateUnit = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.createUnit(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['units-of-measure'] }),
  });
};

export const useConversions = (params) =>
  useQuery({
    queryKey: ['unit-conversions', params],
    queryFn: () => api.getConversions(params),
  });

export const useCreateConversion = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.createConversion(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['unit-conversions'] }),
  });
};
